import { Dispatcher } from "../../../react-core/Flux/Dispatcher";
import { FluxResponse } from "./FluxResponse";

export class SingleDataStoreDispacher<TPayload> extends Dispatcher<FluxResponse<TPayload>> {}
